import Signals from "../../signals/Signals";
var CurrentRefreshingState;
(function (CurrentRefreshingState) {
    CurrentRefreshingState[CurrentRefreshingState["CurrentlyRefreshing"] = 0] = "CurrentlyRefreshing";
    CurrentRefreshingState[CurrentRefreshingState["StartingInterval"] = 1] = "StartingInterval";
    CurrentRefreshingState[CurrentRefreshingState["NotRefreshing"] = 2] = "NotRefreshing";
})(CurrentRefreshingState || (CurrentRefreshingState = {}));
var RefreshingAssetsOnInterval = /** @class */ (function () {
    function RefreshingAssetsOnInterval() {
        this.refreshingState = CurrentRefreshingState.NotRefreshing;
        Signals.ToggleAssetRefreshingOnInterval.add(this.toggleInterval.bind(this));
    }
    RefreshingAssetsOnInterval.prototype.create = function (intervalInMilliseconds) {
        this.refreshIntervalInMilliseconds = intervalInMilliseconds;
        if (this.refreshingState == CurrentRefreshingState.NotRefreshing)
            this.createInterval();
    };
    RefreshingAssetsOnInterval.prototype.createInterval = function () {
        var _this = this;
        console.log("Created interval for refreshing asset data");
        this.refreshingState = CurrentRefreshingState.StartingInterval;
        // Setting an interval for refreshing asset data
        this.refreshingTimer = setInterval(function () {
            _this.refreshingState = CurrentRefreshingState.CurrentlyRefreshing;
            Signals.RefreshAssets.dispatch();
        }, this.refreshIntervalInMilliseconds);
        this.refreshingTimer;
    };
    RefreshingAssetsOnInterval.prototype.stopInterval = function () {
        clearInterval(this.refreshingTimer);
        this.refreshingState = CurrentRefreshingState.NotRefreshing;
    };
    RefreshingAssetsOnInterval.prototype.toggleInterval = function () {
        if (!this.updateAssetsFunction || !this.refreshIntervalInMilliseconds)
            console.warn("Toggle for the asset refreshing was called before creating a interval. Please set the interval when creating component");
        if (this.refreshingState == CurrentRefreshingState.NotRefreshing)
            this.createInterval();
        else
            this.stopInterval();
    };
    return RefreshingAssetsOnInterval;
}());
export default RefreshingAssetsOnInterval;
